<template>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
        active-text-color="#28B6C7">
        <el-menu-item index="/home">Home</el-menu-item>

        <el-submenu index="/Services" id="child">
            <template slot="title">Services</template>
            <el-menu-item index="/recheck-ai">ReCheck</el-menu-item>
            <el-menu-item index="/plugin">Plugin</el-menu-item>
            <el-menu-item index="/ai">AI</el-menu-item>
        </el-submenu>

        <el-submenu index="/Community" id="child1">
            <template slot="title">Community</template>
            <el-menu-item index="/partners">Partners</el-menu-item>
        </el-submenu>

        <el-submenu index="/About us" id="child2">
            <template slot="title">About us</template>
            <el-menu-item index="/metrics">Metrics</el-menu-item>
            <el-menu-item index="/researchers">Researchers</el-menu-item>
            <el-menu-item index="/regional-representatives">Regional Representatives</el-menu-item>
            <el-menu-item index="">News</el-menu-item>
            <el-menu-item index="">Blogs</el-menu-item>
        </el-submenu>

        <el-submenu index="/Contact us" id="child3">
            <template slot="title">Contact us</template>
            <el-menu-item index="/contact-us">Contact us</el-menu-item>
            <el-menu-item index="/help?index=2">FAQ</el-menu-item>
            <el-menu-item index="/offices">Offices</el-menu-item>
            <el-menu-item index="/join">Join Contrimetric Family</el-menu-item>
        </el-submenu>
        <el-button type="primary" class="login_btn" v-openLoginDialog v-show="!isLogin">Log in</el-button>
        <div class="show-name" v-if="isLogin">
            <span class="username">
                {{ $store.getters.getUserInfo.userName }}
            </span> <el-button type="primary" class="login_btn" @click="loginOut">Log out</el-button>
        </div>
        <!-- <el-button type="primary" class="apply_btn" @click="goToRequestDemo">Request a
            Demo</el-button> -->
    </el-menu>
</template>

<script>
export default {
    data() {
        return {
            activeIndex: "/index",
            isLogin: false,
            isLogin: this.$store.getters.getIsLogin,
            userInfo: this.$store.getters.getTokenInfo,
        }
    },
    watch: {
        // 监听路由变化
        "$route.path": {
            handler(routePath) {
                if (routePath == "/about") {
                    this.aboutClass = 'float-hand'
                } else {
                    this.aboutClass = ''
                }
                this.initMenuActive(routePath);
            },
            immediate: true,
        },

        //监听登录状态
        "$store.getters.getIsLogin": {
            handler(isLogin) {
                this.isLogin = isLogin
            },
            immediate: true,
        },

    },
    methods: {
        initMenuActive(routePath) {
            this.activeIndex = routePath;
            if (routePath == '/') {
                this.activeIndex = '/index'
            }
        },
        handleSelect(index) {
            const validRoutes = ["/database", "/codes", "/Publications", "/Team", "/Careers", "/Contact"];

            if (validRoutes.includes(index)) return
            this.$router.push(index);
        },
        goToAbout() {
            this.$router.push('/about');
        },
        goToRequestDemo() {
            this.$router.push('/requestDemo');
        },
        loginOut() {
            this.$store.commit('setTokenInfo', "")
            this.$store.commit('setUserInfo', "")
            this.$store.commit('setIsLogin', "")
            localStorage.setItem('simUserInfo', '')

            this.$message.success({
                showClose: true,
                duration: 1500,
                message: "success logout",
            });
        },
    }
}
</script>

<style lang='scss'>
.el-menu-demo {
    display: flex;
    align-items: center;

    li,
    .el-submenu__title {
        font-size: 18px;
    }

    .float-hand {
        .el-submenu__title {
            border-bottom-color: #28B6C7 !important;

            .about_text {
                color: #28B6C7 !important;
            }
        }
    }

    .login_btn {
        margin-left: 20px;
    }
}


.show-name {
    display: flex;
    align-items: center;

    .username {
        color: #fff;
    }
}

#warp-menu>.el-menu {
    background-color: transparent !important;
}

#warp-menu>.el-menu.el-menu--horizontal {
    border: none;
}

#warp-menu>.el-menu--horizontal>.el-menu-item {
    padding: 0 !important;
    color: #000;
    margin: 0 20px !important;
}

#warp-menu>.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #000;
}

#warp-menu>.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
#warp-menu>.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
    background-color: transparent !important;
}

//子导航栏
//#warp-menu>.el-menu>.el-submenu为子集的li模块
#warp-menu>.el-menu>.el-submenu>.el-submenu__title {
    color: #000;

}

#warp-menu>.el-menu>.el-submenu>.el-submenu__title:hover {
    background: transparent !important;
}

//二级菜单导航箭头颜色
#warp-menu>.el-menu>.el-submenu>.el-submenu__title i {
    color: #000;
}
</style>
